export enum SurveySummaryItemType {
	Errors = 'Errors',
	SurveyPreview = 'SurveyPreview',
	ProgramType = 'ProgramType',
	SurveyName = 'SurveyName',
	OpenCloseDates = 'OpenCloseDates',
	Languages = 'Languages',
	Benchmarks = 'Benchmarks',
	EmployeeDataSource = 'EmployeeDataSource',
	ChosenHierarchy = 'ChosenHierarchy',
	SurveyTitle = 'SurveyTitle',
	SurveyIntro = 'SurveyIntro',
	SurveyInstructions = 'SurveyInstructions',
	Questions = 'Questions',
	QuestionDisplayLogic = 'QuestionDisplayLogic',
	DistributionType = 'DistributionType',
	AudienceName = 'AudienceName',
	SurveyLink = 'SurveyLink',
	SurveyReporting = 'SurveyReporting',
	SurveyAudiences = 'SurveyAudiences',
	ReportingApplication = 'ReportingApplication',
}

export enum SurveySummaryItemTypeId {
	Errors = 1,
	SurveyPreview = 2,
	ProgramType = 3,
	SurveyName = 4,
	Languages = 6,
	Benchmarks = 7,
	EmployeeDataSource = 8,
	SurveyTitle = 10,
	SurveyIntro = 11,
	SurveyInstructions = 12,
	Questions = 13,
	QuestionDisplayLogic = 14,
	SurveyReporting = 17,
	SurveyAudiences = 18,
	ReportingApplication = 19,
	SurveyTextToSpeechStatus = 20,
	SurveyTextToSpeechInstructions = 21,
	PrivacyPolicyStatus = 22,
	SurveyDefinitionStatus = 23,
}
